/**
 * 索赔列表
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/30      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import { Link } from "react-router-dom";
import Lang from "@components/Lang/Lang";
import Locale from "@utils/locale";
import {Row, Col} from 'antd'
import dayjs from "dayjs";
import "./AfterSaleContent.less";

class AfterSaleContent extends React.Component{
    constructor(props) {
        super(props)
    }

    render() {
        const {sourceKey} = this.props;
        console.log("sourceKey",sourceKey)
        return (
            <div className="mt_12">
                {/*list*/}
                {this.props.list.map((item, index) => (
                    <div className="list-item" key={index.toString()}>
                        <Link to={sourceKey=='warehouseInitiated'?`/afterSale/damageDetail?${item.claimDemageOrderId}`:`/afterSale/claim-demage-info?id=${item.claimDemageOrderId}`}>
                            <div className="list-item-con">
                                <Row>
                                    <Col span={Locale=='zh'?10:8}>
                                        <div data-flex>
                                            <i className="ri-arrow-right-double-line"></i>
                                            <div>
                                                <p className={"black89"}>
                                                    {/*<a className="con-txt-head" onClick={(e)=>{*/}
                                                        {/*e.stopPropagation();*/}
                                                    {/*}} href={`/order/sale/detail?id=${item.poId}`}*/}
                                                       {/*target="_blank">{Lang({id: 'DingDan', default:'订单'})} {item.poCode}</a>*/}
                                                    {item.poCode}
                                                </p>
                                                <p className="con-txt-1">
                                                    {Lang({id: 'ShouHouDanHao', default:'售后单号'})}  {item.cdOrderCode}
                                                </p>
                                                <p className="con-txt-1">{item.cdOrderCreateTime?dayjs(item.cdOrderCreateTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={Locale=='zh'?8:6}>
                                        <div className={"black89"}>
                                            {/*<Link className="con-txt-head" onClick={(e)=>{
                                                e.stopPropagation();
                                            }} to={
                                                {
                                                    pathname: '/customer/detail',
                                                    search: `?id=${item.buyerId}`,
                                                    state: {id: item.buyerId},
                                                }
                                            }>
                                                {item.buyerCode}
                                            </Link>*/}
                                            {/*<a className="con-txt-head" onClick={(e)=>{*/}
                                                {/*e.stopPropagation();*/}
                                            {/*}} href={`/customer/detail?id=${item.buyerId}`}*/}
                                               {/*target="_blank">*/}
                                                {item.buyerCode}
                                            {/*</a>*/}
                                        </div>
                                        <div className="con-txt-1">{item.buyerName}</div>
                                        {(item.waitDays>0&&this.props.type!='3')?<div className="con-txt-3">已等待 {item.waitDays} 天</div>:null}
                                    </Col>
                                    <Col span={Locale=='zh'?3:5} data-flex>
                                        <div data-flex className="align-self-center">
                                            <span className={`ui-label ${item.type}`}>{item.typeName}</span>
                                        </div>
                                    </Col>
                                    <Col span={Locale=='zh'?3:5} data-flex="main:right">
                                        <div data-flex className="align-self-center">
                                            {
                                                item.statusMgName?
                                                    <div className={`ui-status-label ui-status-label${item.statusMg}`}>{item.statusMgName}</div>
                                                    :
                                                    null
                                            }

                                            <span className="link">
                                            <i className="ri-arrow-right-s-line"></i>
                                        </span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        )
    }
}

AfterSaleContent.defaultProps = {
}

AfterSaleContent.propTypes = {

}
export default AfterSaleContent;
